module.exports = __webpack_public_path__ + "img/s1.e5bbcd4f.png";